const result = {
    "possibleTypes": {
        "Account": [
            "BankAccountAsset",
            "BeneficiaryAccount",
            "ExternalBankAccountAsset",
            "FXAsset",
            "FixedIncomeFundAsset",
            "TermDepositAsset"
        ],
        "AccountOnboardingRequest": [
            "FXOnboardingRequest",
            "MercuryOnboardingRequest",
            "ProductAccountOnboardingRequest"
        ],
        "AccountsSummaryGroup": [
            "AccountTypeAccountsSummaryGroup",
            "AssetClassAccountsSummaryGroup",
            "BusinessEntityAccountsSummaryGroup",
            "CurrencyAccountsSummaryGroup",
            "ProviderAccountsSummaryGroup"
        ],
        "ApprovalTarget": [
            "AlertAssetRule",
            "BeneficiaryAccount",
            "FXOnboardingRequest",
            "MercuryOnboardingRequest",
            "ProductAccountOnboardingRequest",
            "RecurringTransferAssetRule",
            "RecurringWithdrawalAssetRule",
            "SweepAssetRule",
            "TopUpAssetRule",
            "Transfer",
            "TransferGroup"
        ],
        "Asset": [
            "BankAccountAsset",
            "ExternalBankAccountAsset",
            "FXAsset",
            "FixedIncomeFundAsset",
            "TermDepositAsset"
        ],
        "AssetRule": [
            "AlertAssetRule",
            "RecurringTransferAssetRule",
            "RecurringWithdrawalAssetRule",
            "SweepAssetRule",
            "TopUpAssetRule"
        ],
        "BatchUpdateAssetResult": [
            "BatchUpdateAssetErrorResult",
            "BatchUpdateAssetSuccessResult"
        ],
        "CashManagementStrategyChecklistItem": [
            "AccountCashManagementStrategyChecklistItem",
            "RuleCashManagementStrategyChecklistItem",
            "TransferCashManagementStrategyChecklistItem"
        ],
        "EburyTradeDetails": [
            "EburyDrawdownDetails",
            "EburyFixedForwardDetails",
            "EburyNDFDetails",
            "EburySpotTradeDetails",
            "EburyWindowForwardDetails"
        ],
        "EventActor": [
            "EventActorExternalSystem",
            "EventActorExternalUser",
            "EventActorInternalUser",
            "EventActorScheduledJob",
            "EventActorStandaloneJob"
        ],
        "ExternalAccountDetails": [
            "AirwallexExternalAccountDetails",
            "AkahuExternalAccountDetails",
            "BrexExternalAccountDetails",
            "JpmcExternalAccountDetails",
            "ManualEntryExternalAccountDetails",
            "MercuryExternalAccountDetails",
            "PlaidExternalAccountDetails",
            "QuilttExternalAccountDetails",
            "RampExternalAccountDetails",
            "SaltEdgeExternalAccountDetails",
            "SissExternalAccountDetails",
            "SkriptExternalAccountDetails",
            "StripeExternalAccountDetails"
        ],
        "ExternalBankAccountDataInstitution": [
            "AirwallexExternalBankAccountDataInstitution",
            "AkahuExternalBankAccountDataInstitution",
            "BrexExternalBankAccountDataInstitution",
            "JpmcExternalBankAccountDataInstitution",
            "MercuryExternalBankAccountDataInstitution",
            "PlaidExternalBankAccountDataInstitution",
            "QuilttExternalBankAccountDataInstitution",
            "RampExternalBankAccountDataInstitution",
            "SaltEdgeExternalBankAccountDataInstitution",
            "SissExternalBankAccountDataInstitution",
            "SkriptExternalBankAccountDataInstitution",
            "StripeExternalBankAccountDataInstitution"
        ],
        "ExternalConnection": [
            "AirwallexConnection",
            "AkahuConnection",
            "BrexConnection",
            "JpmcConnection",
            "MercuryConnection",
            "PlaidItem",
            "QuilttConnection",
            "RampConnection",
            "SaltEdgeConnection",
            "SissConnection",
            "SkriptArrangement",
            "StripeConnection"
        ],
        "FXHedge": [
            "ExternalFXHedge",
            "ManagedFXHedge"
        ],
        "FXProvider": [
            "CorpayClient",
            "CurrencycloudAccount",
            "EburyClient"
        ],
        "FXRateDataPoint": [
            "FXRateDataPointDate",
            "FXRateDataPointDateTime"
        ],
        "FXTrade": [
            "CorpayFXTrade",
            "CurrencycloudFXTrade",
            "EburyFXTrade",
            "ManualFXTrade"
        ],
        "FXTradeQuote": [
            "FXTradeFirmQuote",
            "FXTradeQuoteEstimate",
            "FXTradeSyntheticQuote"
        ],
        "FileImportTransactionMatchedItem": [
            "FundUnitOrder",
            "LedgerEntry",
            "WestpacPaymentInstruction"
        ],
        "FundMovement": [
            "Deposit",
            "EburyFXTrade",
            "FundUnitOrder",
            "Transfer"
        ],
        "FundMovementTransactionOption": [
            "FundMovementTransactionAnnotationOption",
            "FundMovementTransactionFundUnitOrderOption",
            "FundMovementTransactionNewDepositOption",
            "FundMovementTransactionStripePayoutOption",
            "FundMovementTransactionTransferNewOption",
            "FundMovementTransactionTransferOption",
            "FundMovementTransactionWestpacPaymentInstructionOption"
        ],
        "FundRateValue": [
            "AccumulatingDistributingFundRate",
            "ApyFundRate"
        ],
        "ImportFile": [
            "MacquarieTransactionImportFile",
            "WestpacTransactionImportFile"
        ],
        "LedgerAccount": [
            "AssetLedgerAccount",
            "BeneficiaryLedgerAccount",
            "CustodyLedgerAccount",
            "FXMarginProviderLedgerAccount",
            "OrganisationLedgerAccount"
        ],
        "Node": [
            "AccountStatement",
            "ActivityStatement",
            "Address",
            "AlertAssetRule",
            "AssetLedgerAccount",
            "BalanceStatement",
            "BankAccountAsset",
            "BankAccountProduct",
            "BeneficiaryAccount",
            "BeneficiaryLedgerAccount",
            "BusinessEntity",
            "CalastoneOrder",
            "CashManagementStrategy",
            "CorpayFXTrade",
            "CurrencycloudFXTrade",
            "CustodyAccount",
            "CustodyLedgerAccount",
            "Deposit",
            "EburyAccount",
            "EburyBeneficiary",
            "EburyFXTrade",
            "Event",
            "ExternalBankAccountAsset",
            "ExternalBankStatement",
            "ExternalFXHedge",
            "ExternalTransactionMatchProposal",
            "FXAsset",
            "FXMarginProviderLedgerAccount",
            "FixedIncomeFundAsset",
            "FundDistribution",
            "FundDistributionAllocation",
            "FundProduct",
            "FundUnitOrder",
            "LedgerTransaction",
            "MacquarieTransactionImportFile",
            "ManagedFXHedge",
            "ManualFXTrade",
            "MonthlyStatement",
            "Notification",
            "NotificationDelivery",
            "NotificationDeliveryAttempt",
            "Organisation",
            "OrganisationLedgerAccount",
            "PaymentInstructionFile",
            "RecurringTransferAssetRule",
            "RecurringWithdrawalAssetRule",
            "ScheduledTransfer",
            "ScheduledWithdrawal",
            "StatementBatch",
            "SweepAssetRule",
            "TermDepositAsset",
            "TermDepositProduct",
            "TopUpAssetRule",
            "Transaction",
            "TransactionMonitoringEvaluation",
            "TransactionMonitoringFinding",
            "Transfer",
            "TransferGroup",
            "UnknownEventObject",
            "UsRIARecord",
            "UserProfile",
            "WestpacPaymentInstruction",
            "WestpacTransactionImportFile"
        ],
        "PaymentIdentifier": [
            "AuBsbPaymentIdentifier",
            "AuPayIdPaymentIdentifier",
            "AuUnitFundPaymentIdentifier",
            "IbanPaymentIdentifier",
            "SwiftBicPaymentIdentifier",
            "SwiftPaymentIdentifier",
            "UsAbaPaymentIdentifier"
        ],
        "Product": [
            "BankAccountProduct",
            "FundProduct",
            "TermDepositProduct"
        ],
        "ScheduledFundMovement": [
            "ScheduledTransfer",
            "ScheduledWithdrawal"
        ],
        "ScreeningEntity": [
            "BeneficiaryAccount",
            "BusinessEntity"
        ],
        "SettlementAccount": [
            "BankAccountAsset",
            "BeneficiaryAccount",
            "FXAsset"
        ],
        "Statement": [
            "AccountStatement",
            "ActivityStatement",
            "BalanceStatement",
            "MonthlyStatement"
        ],
        "SyncAccountToCorpayPayload": [
            "SyncAccountToCorpayErrorPayload",
            "SyncAccountToCorpaySuccessPayload"
        ],
        "TermDepositMaturityInstructions": [
            "TermDepositMaturityInstructionsRollover",
            "TermDepositMaturityInstructionsRolloverPrinciple",
            "TermDepositMaturityInstructionsTransfer"
        ],
        "TimeLogUpdate": [
            "BaseTimeLogUpdate",
            "FXTradeTimeLogUpdate"
        ],
        "TransactionMonitoringEvaluationTarget": [
            "Deposit",
            "Organisation",
            "Transfer"
        ],
        "TransactionMonitoringFindingItemTarget": [
            "BankAccountAsset",
            "Deposit",
            "ExternalBankAccountAsset",
            "FXAsset",
            "FixedIncomeFundAsset",
            "Organisation",
            "TermDepositAsset",
            "Transfer"
        ],
        "TransferUnit": [
            "TransferUnitCurrency",
            "TransferUnitFund"
        ],
        "UserTask": [
            "AlertRuleUserTask",
            "ApprovalRequestUserTask",
            "ExternalAccountRelinkingUserTask",
            "FXAccountOpenedUserTask",
            "FXFundingUserTask",
            "FXProvisioningUserTask",
            "GroupedApprovalRequestUserTask",
            "GroupedExternalAccountRelinkingUserTask",
            "ManageAllocationsUserTask",
            "MercuryProvisioningUserTask",
            "ProductAccountOpenedUserTask",
            "ProductProvisioningUserTask",
            "RuleWithdrawalReplacedUserTask"
        ],
        "ValidateCorpayBeneficiaryPayload": [
            "ValidateCorpayBeneficiaryErrorPayload",
            "ValidateCorpayBeneficiarySuccessPayload"
        ]
    }
};
export default result;
